'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdReplay30 = function MdReplay30(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.3 25.3c0 0.3 0.6 0.6 0.9 0.6 0.2 0 0.3 0 0.5-0.2l0.3-0.4s0.1-0.3 0.1-0.5v-3.3c0-0.2-0.1-0.3-0.1-0.5 0-0.2-0.6-0.5-0.8-0.5-0.2 0-0.4 0-0.5 0.2l-0.4 0.3s-0.1 0.3-0.1 0.5v3.3s0.1 0.4 0.1 0.5z m3.2-1.6c0 0.4 0 1-0.2 1.3l-0.5 1s-0.5 0.5-0.8 0.5-0.7 0.1-1 0.1c-0.8 0-1.3-0.3-1.8-0.6-0.3-0.1-0.3-0.5-0.5-1s-0.2-0.9-0.2-1.3v-1.2c0-0.5 0-1 0.2-1.3l0.5-1s0.5-0.5 0.8-0.5 0.7-0.2 1-0.2 0.7 0 1 0.2 0.5 0.3 0.8 0.5 0.4 0.5 0.5 1 0.2 0.8 0.2 1.3v1.2z m-8.9-1.2c0.7 0 1.2-0.4 1.2-1v-0.3s-0.1-0.2-0.1-0.3-0.2-0.2-0.4-0.2h-0.8s-0.2 0.2-0.3 0.2-0.2 0.1-0.2 0.3v0.3h-1.7c0-0.8 0.7-1.8 1.4-1.8 0.2 0 0.6-0.2 0.8-0.2 0.7 0 1.4 0.3 1.9 0.5 0.4 0.2 0.6 0.9 0.6 1.5v0.5s-0.2 0.3-0.2 0.5-0.1 0.3-0.3 0.3-0.4 0.2-0.5 0.4c0.3 0.2 0.7 0.3 0.8 0.6s0.3 0.7 0.3 1 0 0.7-0.1 0.9-0.3 0.5-0.5 0.6-0.5 0.3-0.9 0.3-0.7 0.2-1 0.2-0.6 0-0.7-0.2-0.6-0.1-0.9-0.3c-0.4-0.2-0.7-1-0.7-1.6h1.4v0.3s0.2 0.2 0.2 0.3 0.1 0.2 0.3 0.2h0.8s0.2-0.2 0.3-0.2 0.2-0.1 0.2-0.3v-0.9s-0.2-0.1-0.2-0.3-0.1-0.1-0.3-0.1h-1v-1.2h0.6z m3.4-14.1c7.3 0 13.4 5.9 13.4 13.2s-6.1 13.4-13.4 13.4-13.4-6-13.4-13.4h3.4c0 5.5 4.5 10 10 10s10-4.5 10-10-4.5-10-10-10v6.8l-8.4-8.4 8.4-8.4v6.8z' })
        )
    );
};

exports.default = MdReplay30;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/replay-30.js
// module id = 3467
// module chunks = 0